import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import { DEFAULT_BRAND } from '../branding/brandPresets';
import { deriveTheme } from '../branding/themeAdapter';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: deriveTheme(DEFAULT_BRAND.colors).vuetify,
        },
    },
});